export interface SaBiaState {
  impactTemplates: any;
  iTGroups: any;
  impactTypes: any;
  impactValues: any;
  maos: any;
  rtos: any;
  raIntQues: any;
  criticalDef: any;
  saBiaIntro;
}

export const initialState: SaBiaState = {
  impactTemplates: [],
  iTGroups: [],
  impactTypes: [],
  impactValues: [],
  maos: [],
  rtos: [],
  raIntQues: [],
  criticalDef: [],
  saBiaIntro: [],
};
